(function FAQ(SectionsDesign) {
  'use strict';

  if (SectionsDesign.faq) return;
  SectionsDesign.faq = {};

  var support = getSupport();

  function init() {
    var configNodes = Array.from(document.querySelectorAll('[data-faq-config]'));

    configNodes.forEach(function (configNode) {
      var section = compose(publicAPI, setEvents, getBlocks, getConfig)(configNode);
      SectionsDesign.faq[section.id] = section;
    });
  }

  init();

  function publicAPI(config) {
    return {
      id: config.sectionId,
      config: config,
      blocks: zipObj(config.blockIds, config.blocks),
      init: init
    };
  }

  // **************************

  function blockEvents(block) {
    if (!block.trigger) return block;
    if (block.trigger.hasAttribute('data-faq-init')) return block;

    block.trigger.setAttribute('data-faq-init', 'true');

    // Click anywhere on the trigger (the H2) toggles the block
    block.trigger.addEventListener('click', function () {
      toggle(block);
    });

    return block;
  }

  function toggle(block) {
    block.collapsed ? expand(block) : collapse(block);
    return block;
  }

  function expand(block) {
    if (!block.button || !block.panel) return block;

    block.button.setAttribute('aria-expanded', 'true');
    block.panel.removeAttribute('hidden');

    // Animate from 0 to content height
    animate(block.panel, 'normal');

    return block;
  }

  function collapse(block) {
    if (!block.button || !block.panel) return block;

    block.button.setAttribute('aria-expanded', 'false');

    // If no WAAPI, just hide immediately
    if (!support.WebAnimations) {
      block.panel.setAttribute('hidden', '');
      return block;
    }

    // Animate closing, then hide at the end
    animate(block.panel, 'reverse', function () {
      block.panel.setAttribute('hidden', '');
    });

    return block;
  }

  function isCollapsed(block) {
    return String(block.button && block.button.getAttribute('aria-expanded')) === 'false';
  }

  /**
   * Animate element height open/close using WAAPI.
   * direction: "normal" (open) or "reverse" (close)
   * done: optional callback after animation finishes (used to set hidden on close)
   */
  function animate(element, direction, done) {
    if (!support.WebAnimations) return;

    // Ensure we can measure height
    element.setAttribute('data-is-animating', 'true');

    // Force a reflow so offsetHeight is accurate
    // (especially important right after removing hidden)
    var height = element.offsetHeight;

    // If opening and the element is currently height:0 due to layout, measure content
    // by briefly setting height:auto and reading scrollHeight
    if (direction === 'normal') {
      height = element.scrollHeight;
    }

    // Cancel any existing animation on the element
    if (element.__faqAnim && typeof element.__faqAnim.cancel === 'function') {
      element.__faqAnim.cancel();
    }

    var anim = element.animate(
      [
        { height: '0px' },
        { height: height + 'px' }
      ],
      {
        duration: 240,
        fill: 'both',
        easing: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        direction: direction
      }
    );

    element.__faqAnim = anim;

    anim.onfinish = function () {
      element.removeAttribute('data-is-animating');
      anim.cancel();
      element.__faqAnim = null;

      if (typeof done === 'function') done();
    };
  }

  // **************************

  function getBlocks(config) {
    config.blocks = config.blockIds.map(block);
    return config;
  }

  function block(blockId) {
    return {
      trigger: document.querySelector('[data-faq-trigger="' + blockId + '"]'),
      button: document.querySelector('[data-faq-button="' + blockId + '"]'),
      panel: document.querySelector('[data-faq-panel="' + blockId + '"]'),

      get collapsed() {
        return isCollapsed(this);
      },
      select: function () {
        return expand(this);
      },
      deselect: function () {
        return collapse(this);
      }
    };
  }

  function setEvents(config) {
    if (!config.blocks) return config;
    config.blocks.forEach(blockEvents);
    return config;
  }

  function getConfig(node) {
    return JSON.parse(node.innerHTML);
  }

  function getSupport() {
    return {
      WebAnimations: (typeof Element !== 'undefined' && Element.prototype && typeof Element.prototype.animate === 'function')
    };
  }

  // **************************

  function zipObj(keys, values) {
    return keys.reduce(function (acc, key, idx) {
      acc[key] = values[idx];
      return acc;
    }, {});
  }

  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function () {
      return funcs.slice(1).reduce(function (res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

})(window.SectionsDesign = window.SectionsDesign || {});